import * as React from "react";

class ButtonCText extends React.Component {
  constructor(props: {}) {
    super(props);
  }

  public render() {
    return (
      <svg
        className="buttonC-text buttonBC-text"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 433.8 139.9"
      >
        <g>
          <path
            fill="#FCFAEE"
            d="M95.9,63.9h8.2v2.2h-5.5v3.1h4.7v2.2h-4.7V75h5.7v2.2h-8.4V63.9z"
          />
          <path
            fill="#FCFAEE"
            d="M106.2,74.5c0-2.2,1.7-3.3,5.8-3.7c0-1-0.5-1.7-1.7-1.7c-0.9,0-1.8,0.4-2.8,1l-1-1.7c1.2-0.7,2.6-1.3,4.2-1.3
		c2.6,0,3.9,1.5,3.9,4.4v5.9h-2.2l-0.2-1.1h-0.1c-0.9,0.8-1.9,1.3-3,1.3C107.4,77.5,106.2,76.2,106.2,74.5z M112,74.4v-2
		c-2.4,0.3-3.3,1-3.3,1.9c0,0.8,0.6,1.1,1.3,1.1C110.8,75.4,111.4,75,112,74.4z"
          />
          <path
            fill="#FCFAEE"
            d="M116.4,76.1l1.2-1.7c0.9,0.7,1.8,1.1,2.7,1.1c1,0,1.5-0.4,1.5-1.1c0-0.8-1-1.1-2.1-1.5
		c-1.3-0.5-2.8-1.3-2.8-2.9c0-1.8,1.5-3.1,3.7-3.1c1.5,0,2.6,0.6,3.4,1.2l-1.2,1.6c-0.7-0.5-1.4-0.9-2.2-0.9c-0.9,0-1.3,0.4-1.3,1
		c0,0.7,1,1,2.1,1.4c1.3,0.5,2.8,1.2,2.8,3c0,1.8-1.4,3.2-4,3.2C118.9,77.5,117.4,76.9,116.4,76.1z"
          />
          <path
            fill="#FCFAEE"
            d="M125.7,72.2c0-3.4,2.3-5.3,4.8-5.3c2.5,0,4.8,1.9,4.8,5.3c0,3.3-2.3,5.3-4.8,5.3
		C128,77.5,125.7,75.5,125.7,72.2z M132.6,72.2c0-1.9-0.8-3.2-2.1-3.2c-1.4,0-2.1,1.2-2.1,3.2c0,1.9,0.8,3.1,2.1,3.1
		C131.9,75.3,132.6,74.1,132.6,72.2z"
          />
          <path
            fill="#FCFAEE"
            d="M137.6,67.1h2.2l0.2,1.3h0.1c0.9-0.9,1.9-1.6,3.3-1.6c2.2,0,3.1,1.5,3.1,4.1v6.3h-2.6v-6
		c0-1.5-0.4-2.1-1.4-2.1c-0.8,0-1.3,0.4-2.1,1.1v6.9h-2.6V67.1z"
          />
          <path
            fill="#FCFAEE"
            d="M148.4,77.2c0.6-1.2,1.2-2.9,1.6-4.2l1.9,0.8c-0.4,1.4-0.9,3.2-1.5,4.4L148.4,77.2z M153.1,65.6
		c-0.8,1.5-1.8,2.8-2.8,3.8c-0.4-0.4-1.2-1.2-1.8-1.5c1.7-1.4,3-3.6,3.7-6l2.2,0.5c-0.1,0.4-0.3,0.9-0.5,1.3h10.5v1.8h-7.7v1h6.7
		v1.7h-6.7v1.1h7.1v1.7h-7.1V72c0.9,0.7,2.1,1.6,2.7,2.1l-1.4,1.5c-0.6-0.7-2-1.8-2.9-2.5l0.6-0.6h-1.2v-6.9H153.1z M163,78.1
		c-0.2-0.6-0.5-1.5-0.9-2.4c-0.3,2.2-0.9,2.8-2.9,2.8h-3.6c-2.6,0-3.2-0.6-3.2-2.5v-2.8h2.1V76c0,0.5,0.2,0.6,1.3,0.6h3.2
		c0.9,0,1-0.2,1.1-1.7c0.4,0.3,1.3,0.6,1.9,0.8c-0.3-0.8-0.7-1.6-1-2.4l2-0.6c0.7,1.5,1.7,3.4,2.1,4.6L163,78.1z"
          />
          <path
            fill="#FCFAEE"
            d="M171.6,73.1c-0.2-0.5-0.6-1.3-1-2.1v7.8h-1.9V72c-0.5,1.4-1,2.6-1.6,3.5c-0.2-0.6-0.6-1.4-0.9-1.9
		c1-1.4,2-3.9,2.4-6h-2v-2h2.2V62h1.9v3.7h1.8v2h-1.8v0.8c0.5,0.7,1.8,2.6,2.1,3.1L171.6,73.1z M176.5,73.9c-0.6,2.2-2,3.8-3.7,4.6
		c-0.2-0.4-0.8-1-1.1-1.4c1-0.5,1.9-1.3,2.5-2.3h-2v-1.4h2.8l0.3-0.1L176.5,73.9z M183,73c-0.9,0.6-1.8,1.3-2.6,1.8
		c0.8,0.8,1.9,1.5,3,1.9c-0.4,0.4-1,1.1-1.3,1.6c-1.3-0.6-2.4-1.6-3.3-2.9v1.4c0,0.9-0.2,1.4-0.8,1.7c-0.6,0.3-1.4,0.3-2.5,0.3
		c-0.1-0.5-0.3-1.3-0.5-1.7c0.6,0,1.3,0,1.5,0c0.2,0,0.3-0.1,0.3-0.3v-4h-3v-1.5h4.3c-0.8-0.3-1.7-0.7-2.5-0.9l0.5-0.6h-3.7v-1.6
		h4.3v-0.7h-3.1v-1.5h3.1v-0.7h-3.8V64h1.9c-0.2-0.5-0.5-1-0.8-1.4l1.6-0.6c0.4,0.5,0.9,1.3,1.1,1.8l-0.5,0.2h2.9l-0.4-0.1
		c0.3-0.5,0.7-1.4,0.9-1.9l1.9,0.5c-0.4,0.5-0.8,1-1.1,1.5h2.2v1.5h-4v0.7h3.5v1.5h-3.5v0.7h4.3v1.6h-4.5c0.8,0.3,1.7,0.6,2.3,1
		l-1.1,1.3c-0.3-0.1-0.6-0.3-0.9-0.5v0.9c0.2,0.4,0.4,0.8,0.6,1.1c0.7-0.6,1.5-1.3,2-1.9L183,73z"
          />
          <path
            fill="#FCFAEE"
            d="M201.2,63.9c-0.6,1.7-1.4,3.8-2.2,5.3c1.5,1.6,1.8,3,1.8,4.2c0,1.4-0.3,2.2-1,2.7c-0.3,0.3-0.8,0.4-1.3,0.5
		c-0.4,0.1-1,0.1-1.6,0c0-0.6-0.2-1.5-0.5-2.1c0.4,0,0.8,0.1,1.1,0c0.3,0,0.5-0.1,0.7-0.2c0.3-0.2,0.5-0.6,0.5-1.2
		c0-1-0.4-2.3-1.9-3.7c0.5-1.3,1.1-3.1,1.6-4.5h-2.3v13.8h-2.1V63.4c-0.5,1.4-1.2,2.7-1.9,3.8h1.3v1.9h-2.7
		c-0.4,0.5-0.8,0.9-1.2,1.3h3.2v8.1h-2v-0.7H188v0.9h-1.9v-5.5c-0.3,0.2-0.6,0.4-0.9,0.5c-0.2-0.5-0.8-1.4-1.2-1.8
		c1.6-0.8,3-1.8,4.3-3h-3.8v-1.9h3.1v-1.5h-2.4v-1.8h2.4v-1.7h2v1.7h1.9v0.9c0.3-0.6,0.6-1.3,0.9-2l1.9,0.5V63h5.2l0.3-0.1
		L201.2,63.9z M190.9,72.1H188v1.2h2.9V72.1z M190.9,76.1v-1.3H188v1.3H190.9z M189.9,67.2c0.3-0.5,0.7-1,1-1.5h-1.3v1.5H189.9z"
          />
          <path
            fill="#FCFAEE"
            d="M213.2,67.8c1.9,1.4,4.7,3.5,6,4.9l-1.8,1.6c-1.1-1.3-3.6-3.4-5.5-4.9v9.3h-2.3V70c-1.6,1.7-3.6,3.3-5.7,4.4
		c-0.3-0.6-1-1.5-1.5-1.9c3.3-1.5,6.1-4.3,7.8-7.1h-7.2v-2.2h15.6v2.2h-5.6c-0.3,0.6-0.7,1.1-1,1.7v1.9L213.2,67.8z"
          />
          <path
            fill="#FCFAEE"
            d="M227.1,72.4V77c0,0.8-0.1,1.2-0.6,1.5c-0.5,0.3-1.1,0.3-2,0.3c-0.1-0.5-0.3-1.2-0.5-1.6c0.5,0,1,0,1.2,0
		c0.2,0,0.2-0.1,0.2-0.2v-4.5h-1.9v-6.5h1.6c0.1-0.5,0.1-0.9,0.2-1.4h-2.5v5.1c0,2.7-0.2,6.6-1.3,8.9c-0.3-0.3-1.1-0.9-1.5-1.1
		c0.9-2.2,1-5.4,1-7.8v-7h7.9v1.8h-1.6c-0.1,0.5-0.3,1-0.4,1.4h2.1v6.5H227.1z M225.1,73.5c-0.3,1.4-0.7,2.8-1.2,3.8
		c-0.3-0.3-1-0.6-1.4-0.8c0.5-0.8,0.9-2.1,1.1-3.3L225.1,73.5z M227.3,67.4h-2.2v1.1h2.2V67.4z M225.1,70.9h2.2v-1.1h-2.2V70.9z
		 M228.2,76.5c-0.2-0.7-0.6-2-1-2.9l1.3-0.5c0.4,0.9,0.9,2.1,1,2.8L228.2,76.5z M232.8,76.4c-0.8,0.9-2.2,1.9-3.3,2.4
		c-0.3-0.4-0.9-0.9-1.3-1.3c1.1-0.5,2.3-1.4,3-2.2L232.8,76.4z M231.9,65.7c0.1-0.4,0.1-0.8,0.2-1.3h-2.8v-1.8h7.6v1.8h-2.8
		c-0.1,0.4-0.3,0.9-0.4,1.3h2.8v9.5h-6.8v-9.5H231.9z M234.6,67.3h-3.1v1.2h3.1V67.3z M234.6,69.9h-3.1v1.2h3.1V69.9z M234.6,72.5
		h-3.1v1.2h3.1V72.5z M234.9,75.4c0.8,0.7,1.9,1.7,2.4,2.3l-1.6,1.1c-0.5-0.7-1.5-1.7-2.4-2.4L234.9,75.4z"
          />
          <path
            fill="#FCFAEE"
            d="M238.4,77.3c0.9-0.8,1.7-2,2.2-3.1l1.8,0.8c-0.5,1.1-1.3,2.4-2.2,3.3L238.4,77.3z M254.5,67.6h-15.6v-1.7h3.8
		c-0.1-0.3-0.2-0.7-0.4-1l1.4-0.3h-3.9V63h5.8c-0.1-0.3-0.2-0.6-0.3-0.8l2.1-0.4c0.2,0.4,0.4,0.8,0.5,1.2h5.6v1.7h-3.7l1.4,0.3
		c-0.2,0.4-0.4,0.7-0.6,1h3.8V67.6z M252.5,73.7H247c0.7,0.4,1.4,0.8,1.9,1.2l-1.3,1.3c-0.6-0.6-1.8-1.3-2.8-1.8l0.7-0.7h-4.6v-5.5
		h11.6V73.7z M248.4,76.9c0.7,0,0.8-0.2,0.9-1.5c0.4,0.3,1.3,0.6,1.8,0.7c-0.2,2-0.8,2.5-2.5,2.5h-2.9c-2.3,0-2.8-0.5-2.8-2.2v-1.9
		h2.1v1.9c0,0.5,0.1,0.5,1,0.5H248.4z M250.4,69.5H243v0.8h7.5V69.5z M250.4,71.6H243v0.8h7.5V71.6z M244.3,64.6
		c0.2,0.4,0.4,0.9,0.5,1.3h3.7c0.2-0.4,0.4-0.9,0.5-1.3H244.3z M252.5,74.1c0.9,1,1.8,2.3,2.2,3.2l-1.9,0.8
		c-0.3-0.9-1.2-2.3-2.1-3.3L252.5,74.1z"
          />
          <path
            fill="#FCFAEE"
            d="M271,76.7c0.3,0,0.4-0.2,0.4-1.9c0.4,0.3,1.3,0.7,1.8,0.8c-0.2,2.4-0.7,3.1-2,3.1H270c-1.6,0-2-0.6-2-2.5
		v-3.6h-0.8c-0.3,2.8-0.9,5.1-3.9,6.4c-0.2-0.4-0.7-1.1-1.1-1.5v0.4h-3.5v0.8H257v-6.2h5.3v4.8c2.2-1,2.6-2.6,2.8-4.7h-1.2v-4.9
		c-0.2,0.2-0.4,0.4-0.6,0.6c-0.3-0.4-1.1-1.2-1.5-1.5l0.1-0.1h-5.6v-1.7h2.7c-0.2-0.7-0.5-1.6-0.9-2.3l1.8-0.6
		c0.4,0.7,0.8,1.7,1,2.3l-1.4,0.5h3.2v1c1-1,2-2.4,2.6-3.7l2,0.6c-0.6,1.4-1.5,2.8-2.5,4h6.2c-0.8-1.2-1.9-2.6-3-3.7l1.5-1
		c1.4,1.4,3.1,3.4,3.8,4.8l-1.6,1.2c-0.1-0.2-0.2-0.4-0.4-0.6v5.2h-1.1v3.6c0,0.5,0,0.6,0.3,0.6H271z M262.1,69.1H257v-1.6h5.1V69.1
		z M257,69.9h5.1v1.6H257V69.9z M260.5,74.1h-1.7v2h1.7V74.1z M266,70.7h3.2v-2H266V70.7z"
          />
          <path
            fill="#FCFAEE"
            d="M290,71v7.8h-2.4v-1h-12.4V71h2.4v4.7h3.8V70h-5.2v-6.5h2.3V68h3v-6h2.4v6h3.1v-4.5h2.4V70h-5.5v5.7h3.8V71
		H290z"
          />
          <path
            fill="#FCFAEE"
            d="M307.2,72.6c-0.5-0.6-1.4-1.4-2.3-2.1c-0.4,0.6-0.8,1.1-1.2,1.5c-0.3-0.3-0.9-0.6-1.4-0.9
		c1.6,2.1,4.2,4,6.9,5c-0.5,0.4-1.2,1.4-1.6,2c-2.2-1-4.2-2.6-5.8-4.6v5.2h-2.2v-5.1c-1.6,1.9-3.6,3.5-5.8,4.4
		c-0.3-0.5-1-1.4-1.5-1.8c2.9-1.1,5.7-3.4,7.3-5.8v-4.2h-6.6v-2.1h6.6V62h2.2v2.2h6.8v2.1h-6.8v4c0.1,0.1,0.2,0.3,0.3,0.4
		c1.2-1,1.9-2.6,2.3-4.3l2.1,0.4c-0.2,0.7-0.4,1.3-0.6,1.9c1,0.8,2.3,1.7,2.9,2.4L307.2,72.6z M297.9,66.8c-0.2,0.7-0.4,1.3-0.6,1.9
		c0.6,0.6,1.3,1.2,1.7,1.6l-1.4,1.5c-0.3-0.3-0.7-0.8-1.2-1.3c-0.6,1-1.3,1.8-2.1,2.5c-0.3-0.4-1.2-1.1-1.7-1.4
		c1.6-1.1,2.7-3,3.2-5.2L297.9,66.8z"
          />
          <path
            fill="#FCFAEE"
            d="M314.2,67.5c1.6,0,2.9,1.3,2.9,2.9s-1.3,2.9-2.9,2.9c-1.6,0-2.9-1.3-2.9-2.9S312.6,67.5,314.2,67.5z
		 M314.2,72c0.9,0,1.6-0.7,1.6-1.6s-0.7-1.6-1.6-1.6c-0.9,0-1.6,0.7-1.6,1.6S313.3,72,314.2,72z"
          />
        </g>
      </svg>
    );
  }
}

export default ButtonCText;



// WEBPACK FOOTER //
// ./src/storyA/components/ButtonCText.tsx